(function () {
    'use strict';

    angular
        .module('app')
        .component('categoriaWebListAdmin', {
            templateUrl: 'app/components/web/admin/categoriaweb/categoria-web-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, CategoriaWeb, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = CategoriaWeb;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (CategoriaWeb) {
                            return CategoriaWeb.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'web.categoriaWeb.admin.delete.title',
                                body: 'web.categoriaWeb.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();
